/* eslint-disable react/no-array-index-key, class-methods-use-this */

import FormControl from '@material-ui/core/FormControl'
import Icon from '@material-ui/core/Icon'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
/**
 *
 * ListFilters
 *
 */
import cn from 'classnames'
import { isEqual } from 'lodash'
import React from 'react'

import LabelWrapper from '../LabelWrapper'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: '100px',
  },
  fullWidth: {
    width: '100%',
  },
  formControl: {
    backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
    color: `var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor}) !important`,
    minWidth: '100px',
    '& .MuiInputBase-root': {
      display: 'flex',
      justifyContent: 'stretch',
      height: '34px',
      lineHeight: 1,
    },
    '& .MuiInputBase-input:focus': {
      background: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBgColor})`,
    },
    '&:focus': {
      background: 'none',
    },
    '& .MuiSelect-root': {
      display: 'flex',
      alignItems: 'center',
      padding: '0 30px 0 10px',
      height: '34px !important',
    },
  },
  border: {
    border: `1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`}`,
    borderRadius: '4px',
    overflow: 'hidden',
  },
  DividerRoot: {
    backgroundColor: `${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`} !important`,
    width: '100%',
  },
  selectEmpty: {
    marginTop: theme.spacing(8),
  },
  stgSelect: {
    background: 'transparent',
    fontSize: '14px',
    color: `${`var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`} !important`,
    '&:before': {
      borderBottom: 'none !important',
    },
    '&:after': {
      background: 'none',
      borderBottom: 'none !important',
    },
    '&:focus': {
      background: 'none',
      borderBottom: 'none !important',
    },
    '&:hover': {
      borderBottom: 'none',
    },
    '& input': {
      padding: '0px',
    },
    '& .MuiSelect-selectMenu* ': {
      width: '90%',
    },
    '& span': {
      lineHeight: 1,
    },
  },
  stgLabel: {
    margin: '0  0 8px 0',
    display: 'block',
  },
  stgInlineLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  mandatory: {
    color: theme.status.errorColor,
  },
  width90: {
    width: '90%',
  },
  margin5: {
    marginRight: 5,
  },
  optIcon: {
    marginRight: '8px',
  },
  label: {
    margin: 0,
    fontSize: theme.typography.fontSizeSm,
    wordWrap: 'break-word',
    textAlign: 'left',
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    '& .required': {
      marginLeft: '0.25rem',
      color: theme.status.errorColor,
    },
  },
  disabled: {
    backgroundColor: `var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`,
    borderColor: `var(--gameday-inputField-inputBorderDisabled, ${theme.inputField.inputBorderDisabled})`,
    color: `var(--gameday-inputField-inputTextColorDisabled, ${theme.inputField.inputTextColorDisabled})`,
    opacity: theme.inputField.inputDisabledOpacity,
    '&:hover': {
      cursor: 'not-allowed',
    },
  },
  dropdown: {
    '& .has-error $formControl': {
      borderColor: theme.status.errorColor,
      backgroundColor: theme.status.errorBG,
    },
  },
  willDelete: {
    textDecoration: 'line-through',
    opacity: 0.6,
    '&::before': {
      display: 'none',
    },
  },
  menuItem: {
    fontSize: theme.typography.fontSizeSm,
    '&.Mui-disabled': {
      backgroundColor: `${theme.inputField.inputBGDisabled} !important`,
    },
  },
})

class DropDown extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filterData: this.props.filterData,
      selected: this.props.selected,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected !== this.props.selected) {
      this.setState({
        selected: nextProps.selected,
      })
    }
    if (!isEqual(nextProps.filterData, this.props.filterData)) {
      this.setState({
        filterData: nextProps.filterData,
      })
    }
  }

  handleChange = event => {
    // eslint-disable-next-line prefer-destructuring
    const value = event.target.value
    this.setState({ selected: value })
    this.props.onChange(value)
  }

  optionData = item => {
    if (item.value) {
      item.value.map(option => {
        const ke = `${option.keyprefix}_${option.name}`
        return (
          <MenuItem key={ke} value={option.id}>
            {option.name}
          </MenuItem>
        )
      })
    }
  }

  render() {
    const {
      classes,
      defaultOption,
      label,
      isMandatory,
      isError,
      defaultValue,
      errorMessage,
      customCol,
      customMargin,
      customPadding,
      customWidth,
      disabled,
      icon,
      fullWidth,
      isLabelInline,
      border,
      className,
      errorText,
      helperText,
      id,
      isRequired,
      isToolTip,
      justify,
      multipleFields,
      noMobile,
      notWrapper,
      noWrap,
      spacing,
      toolTipIcon,
      toolTipIconColor,
      toolTipIconSize,
      toolTipPosition,
      toolTipText,
      willDelete,
      withBorder,
      withDivider,
      ...rest
    } = this.props
    const { selected, filterData } = this.state

    return (
      <React.Fragment>
        {(filterData || []).map((item, key) => (
          <LabelWrapper
            className={cn(classes.dropdown, className)}
            customCol={customCol}
            customMargin={customMargin}
            customPadding={customPadding}
            customWidth={customWidth}
            disabled={disabled || willDelete}
            errorText={errorText || errorMessage}
            fullWidth={fullWidth}
            helperText={helperText}
            id={id}
            isLabelInline={isLabelInline}
            isRequired={isRequired || isMandatory}
            isToolTip={isToolTip}
            justify={justify}
            label={label}
            multipleFields={multipleFields}
            noMobile={noMobile}
            notWrapper={notWrapper}
            noWrap={noWrap}
            spacing={spacing}
            toolTipIcon={toolTipIcon}
            toolTipIconColor={toolTipIconColor}
            toolTipIconSize={toolTipIconSize}
            toolTipPosition={toolTipPosition}
            toolTipText={toolTipText}
            willDelete={willDelete}
            withBorder={withBorder || border}
            withDivider={withDivider}
            key={`item${
              // biome-ignore lint/suspicious/noArrayIndexKey: TODO
              key
            }`}
            {...rest}
          >
            <FormControl
              classes={{ root: classes.formControl }}
              className={cn(
                classes.formControl,
                (border || withBorder) && classes.border,
                fullWidth && classes.fullWidth
              )}
              error={isError}
            >
              <Select
                value={selected}
                onChange={this.handleChange}
                displayEmpty
                name={item.key}
                className={cn(classes.stgSelect, {
                  [classes.willDelete]: willDelete,
                })}
                disabled={!!disabled || willDelete}
                id={`${id}-dropdown`}
                style={
                  customWidth ? { width: `${border || withBorder ? Number(customWidth) - 2 : customWidth}px` } : {}
                }
                classes={{ disabled: classes.disabled }}
              >
                {defaultOption && (
                  <MenuItem value="" className={classes.menuItem}>
                    {defaultValue || 'Please Select'}
                  </MenuItem>
                )}
                {/* biome-ignore lint/complexity/useOptionalChain: TODO */}
                {item.value &&
                  item.value.map(option => (
                    <MenuItem
                      className={classes.menuItem}
                      disabled={option.disabled || false}
                      key={`${item.key_prefix}_${option.id}`}
                      value={option.id}
                    >
                      {icon ? <Icon className={classes.optIcon}>{option.icon}</Icon> : null}
                      <span>{option.name}</span>
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </LabelWrapper>
        ))}
      </React.Fragment>
    )
  }
}

DropDown.defaultProps = {
  onChange: () => {},
  customWidth: null,
  filterData: [],
  selected: [],
  defaultOption: true,
  icon: false,
  fullWidth: false,
  isLabelInline: false,
  border: false,
  notWrapper: true,
}

const DropDownStyle = withStyles(styles)(DropDown)
DropDownStyle.displayName = 'DropDown'
export default DropDownStyle
